import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';
import {useMultiStyleConfig} from '@chakra-ui/system';

import {core} from '../../design-tokens/light-legacy';

const parts = [`container`, `button`] as const;
export type NavbarParts = (typeof parts)[number];

const NavbarTheme = createMultiStyleConfigHelpers(parts).definePartsStyle({
  container: {
    baseStyle: {
      borderBottom: core.borders.base,
    },
  },
  button: {
    baseStyle: {
      color: `colors.text.base`,
      _hover: {
        color: `brand.light`,
      },
      _active: {
        color: `brand.light`,
      },
    },
    defaultProps: {
      variant: `plain`,
    },
  },
});

export default NavbarTheme;

export const useNavbarStyleConfig = <Part extends NavbarParts>(
  part: Part,
  props?: Parameters<typeof useMultiStyleConfig>[1],
): (typeof NavbarTheme)[Part]['baseStyle'] => {
  return useMultiStyleConfig(`Navbar.${part}`, props ?? {}) as (typeof NavbarTheme)[Part]['baseStyle'];
};
